import { useOutletContext } from 'react-router-dom';
import { ClientSubscription } from '../ClientSubscription';

interface ClientData {
  id: number;
  firstname: string;
  lastname: string;
  email: string;
  phone?: string;
  email_verified: boolean;
  last_login?: string;
  created_at: string;
}

interface ContextData {
  client: ClientData;
  cachedData: Record<string, any>;
  handleDataLoaded: (tabName: string, data: any) => void;
}

export function SubscriptionTab() {
  const { client, cachedData, handleDataLoaded } = useOutletContext<ContextData>();

  return (
    <div>
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-xl font-semibold text-gray-900 mb-2">My Subscriptions</h3>
        <p className="text-gray-600">Manage Subscriptions</p>
      </div>
      <div className="p-6">
        <ClientSubscription 
          customerId={client.id} 
          cachedData={cachedData.subscription}
          onDataLoaded={(data) => handleDataLoaded('subscription', data)}
        />
      </div>
    </div>
  );
}